import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

// ✅ Import Custom Components
import CustomPaginationActionsTable from './AddassetdraftTable';
import SubmittedTable from './SubmittedTable';
import PreviewEdit from './PreviewEdit';
import PdfModal from '../../../../data/pdfmodal';
import fetchPDF from '../../../../data/fetchPDF';

// ✅ Import API Slices for RTK Query
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice';
import { 
  useGetAssetsQuery, 
  useValidatetagsMutation 
} from '../../../../features/addassets/addassetApiSlice';

import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import { useGetAssetsFinalQuery } from '../../../../features/addassets/addassetfinalApiSlice';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import { useGetbrandmasterQuery } from '../../../../features/brandmaster/brandmasterApiSlice';
import { useGetModelNumbersQuery } from '../../../../features/modelnumber/modelNumberApiSlice';
import { useUploadFileMutation } from '../../../../features/fileupload/fileuploadApiSlice';
import { useGetVendorMasterQuery } from '../../../../features/vendormaster/vendormasterApiSlice';

// ✅ Import MUI Components
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

// ✅ Import Date Handling Libraries
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

// ✅ Import React Router & Redux Hooks
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import useAuth from '../../../../features/hooks/useAuth';

// ✅ Import Styles & Utility Libraries
import * as XLSX from 'xlsx';
import { 
  HeadingWrap, Span, CommonButton,  
  BackButtonSpan
} from '../../../../Styles/CommonStyles';


const Container = styled.div`
width: 100%;
`;
const Wrapper = styled.div`
padding: 5px;
display: flex;
flex-direction: column;
`;
const SelectContainer = styled.div`
  margin: 15px;
  display: flex;
  align-items: center;
`;
const InputFile = styled.input`
  width: 180px;
  display: none;
`;
const SpecificationContainer = styled.div`
  height: 60vh;
  background-color: #ccdee7;
  border-radius: 10px;
  width: 100%;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
const Specwrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;
const SpecItemwrapper = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
`;
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`;
const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  height: 40px;
  padding: 6px 16px;
  border-radius: 4px;
  border-width: 0;
  background-color: #008080;
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
  margin: 8px;
`;
const NextButton = styled(StyledButton)``;
const SubmitButton = styled(StyledButton)``;
const AsetfmContainer = styled.div`
  width: 100%;
  height: 100%;
`;
const AsetfmWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;
const LeftAsetfmWrapper = styled.div`
  width:50%;
  height: 100%;
  flex: 1;
`;
const RightAsetfmWrapper = styled.div`
  width:50%;
  height: 100%;
  flex: 1;
`;
const InputAsetfmWrapper = styled.div`
  margin: 10px;
`;
const TagsContainer = styled.div`
  height: 30vh;
  width: 100%;
  overflow-y: auto;
`;
const FormatContainer = styled.div``
const Buttonwrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top:40px;
`;
const ExlDownloadButton = styled.button`
  margin-right: 30px;
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const DraftTableCont = styled.div``;
const DraftTableWrap = styled.div``;
const FormTabCont = styled.div``;
const FormCont = styled.div``;
const FirstpageForm = styled.form``;
const ConfirmButton = styled(CommonButton)``;
const DraftSubButtonCon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;
const AllWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: space-around;
    flex-grow: 1;
    row-gap: 50px;
`;
const OptionContainer = styled.div`
    width:350px;
    display: flex;
    height:150px;
    background-color:#fff;
    /* align-items: center;
    justify-content: center; */
    color: #58548E;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 1.2857142857142856rem;
    line-height: 1.334;
    letter-spacing: 0em;
    margin-left: 24px;
    font-weight: 700;
    cursor: pointer;
    position: relative;
    transition: box-shadow 0.3s;
    &:hover{
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    }
`;
const TagsAsetfmWrapper = styled.div`
  display: flex;
  background-color:#8BA8B7;
`;
const InnerContainer = styled.div`
    display:flex;
    border-left: 3px solid #955EFF;
    align-items: center;
    position: absolute;
    top: 20%;
    bottom: 20%;
    padding: 25px;
`;
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  cursor: pointer;
`;
const SelectFileReset = styled.button`
  background-color: transparent;
  color: #999;
  border: none;
  font-size: 35px;
  cursor: pointer;
  padding: 0;
  margin-left:2px;
`;
const UploadPdfWrapper = styled.div`
  display: flex;
  align-items:center;
`;
const ViewButton = styled.button`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  margin-left: 5px;
  cursor: pointer;  
`;

// Function to check for duplicates tags
const checkDuplicates = (arr, key) => {
  const seen = new Set();
  const duplicates = new Set();
  arr.forEach(item => {
    const value = item[key];
    if (value === "") {
      return; // Skip empty values
    }
    if (seen.has(value)) {
      duplicates.add(value);
    } else {
      seen.add(value);
    }
  });
  return duplicates;
};

const  formatCategory = (category) => {
  if (category.length < 3) {
      // Pad with '0's to ensure the string has at least 3 characters
      category += '0'.repeat(3 - category.length);
  }
  return category.slice(0, 3);
}

const getFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}${month}${day}`;
}

const FinalObjInitialVal = {
  orderno:"", category:"", name:"", specification:[], tags:[], quantity:null, pur_store:"", cur_store:"",
  unit_price:"", oem:"", model_no:"", vendor:"", alloc_ofc:"", purchase_date:null, installation_date:null,
  warrantyexp_date:null, ledge_ref:"", bill_ref:"", remarks:"", in_transit:false, last_trans_date:null,
  olderAssetsLot:"", old_issue_date:null, form_13_compiled:false,
}

const Addassets = () => {
  const [clicked, setClicked] = useState();
  const [tags, setTags] = useState([]);
  const [temptags, setTemptags] = useState({});
  const [bclick, setBclick] = useState('');
  const [conclicked, setConclicked] = useState(false);
  const [finalSubClicked, setFinalSubClicked] = useState(false);
  const [reqid, setreqId] = useState("");
  const [submittedEditClick, setSubmittedEditClick] = useState('');
  const [duplicate, setDuplicate] = useState({});
  const inputFile = useRef(null);
  const inputPdfFile = useRef(null);
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState(null);
  const [file, setFile] = useState(null);
  const [selectedfile, setSelectedFile] = useState(null);
  const [reselectedfile, setReselectedFile] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [finalobj, setFinalobj] = useState(FinalObjInitialVal);

  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth();
  let user_current_office = (useSelector((state) => state.office.off))
  
  // Get auth token for API requests
  const token = useSelector(state => state.auth.token);

  // handle file upload
  const handlePdfFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        if(!reqid.length){
          setSelectedFile(file);

        } else {
          if(!addassetdata?.entities[reqid]?.pdfPath?.length){
            setSelectedFile(file);
          }else{
            setReselectedFile(file)
          }
        }
      } else {
        alert('Please select only PDF file.');
        event.target.value = null;
      }
    }
  }

  const  closeModal = () =>{
    setModalIsOpen(false);
  };

  const handleviewFile = () =>{
    setModalIsOpen(true)
  };

  const handlePdfUploadButtonClick = () => {
    inputPdfFile?.current?.click();
  };

  let Tags = [];
  for (let i = 1; i <= finalobj?.quantity; i++) { Tags.push(i) }

  //all models data
  const {
    data: allmodels
  } = useGetModelNumbersQuery('allmodellist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let allmodeldata = allmodels ? Object.values(allmodels?.entities) : []
  let allmodel = allmodeldata || []

  let modelOptions = ['Not Available', 'Not Applicable'].concat(allmodel?.filter(x => ( x.asset === finalobj?.name && x.brand === finalobj.oem)).map(a => a.modelno));

  // store offices 
  const {
    data: allstoreoffices
  } = useGetStoreOfficesQuery('allstorelists', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let storedata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []

  // assetmaster data called
  const {
    data: assetmasters,
    isSuccess,
    isError,
  } = useGetAssetMastersQuery('assetmasterlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const {
    data: addassetdata
  } = useGetAssetsQuery('addassetdata', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });
  
  const [uploadFile, { isLoading }] = useUploadFileMutation();

  const [validatetags] = useValidatetagsMutation();


  //All Brands Name call 
  const {
    data: allbrands
  } = useGetbrandmasterQuery('allbrandlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let allbrandsdata = allbrands ? Object.values(allbrands?.entities) : [];
  let allBrands = allbrandsdata || [];
  let brandOptions = allBrands?.filter(x => x.applicableCategory?.includes(finalobj?.category))?.map(elm => elm.name);

  //usercall/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  //Vendor master call
  const {vendormaster} = useGetVendorMasterQuery("vendormasterList", {
    selectFromResult: ({ data }) => ({
      vendormaster: data?.entities
    }),
  })
  
  //Using useeffect to set purchase store office.
  useEffect(() => {
    if (user_current_office && allstoreoffices?.entities) {
        const officeList = Object.values(allstoreoffices.entities).map(x => x.storeoffice);
        const isOfficePresent = officeList.includes(user_current_office);

        setFinalobj(prev => ({
            ...prev,
            pur_store: isOfficePresent ? user_current_office : "",
            cur_store: isOfficePresent ? user_current_office : ""
        }));
    }
  }, [allstoreoffices, user_current_office, bclick]); 

  const handleDraftclick = () => {
    setBclick('draft')
  }

  const handleNewclick = () => {
    setBclick('new');
    setConclicked(false);
    setClicked(false);
    setreqId("");

    if (inputPdfFile.current) inputPdfFile.current.value = null;
    if (inputFile.current) inputFile.current.value = null;

    setSelectedFile(null);
    setReselectedFile(null);
    setFile(null);
  };

  const handleSubmittedclick = () => {
    setBclick('submitted')
    setConclicked(false);
    setreqId("");
    setClicked(false);

    if(inputPdfFile.current) inputPdfFile.current.value = null;
    if(inputFile.current) inputFile.current.value = null;

    setSelectedFile(null);
    setReselectedFile(null);
    setFile(null);
  };

  const NexthandleClick = () => {
    setClicked(true)
  };

  const backhandleClick = () => {
    setClicked(false)
  };

  const handlefirstpageformsubmit = (e) => {
    e.preventDefault()
  };


  const handleConclick = () => {
    // Safely extract category and name from finalobj
    const category = finalobj?.category;
    const name = finalobj?.name;

    // Safely retrieve asset category and asset details
    const assetCategory = Object.values(assetmasters?.entities)?.find(x => x.Category === category);
    const assetDetails = assetCategory?.Asset?.find(y => y.Name === name);

    // Perform validation with added safety checks
    const specificationsCount = assetDetails?.Specifications?.length ?? 0;
    const selectedSpecificationsCount = Object.values(finalobj?.specification)?.length ?? 0;

    if (specificationsCount === selectedSpecificationsCount) {
        setConclicked(true);
    } else {
        alert('Please select all the specifications');
    }
  };

  // Function to handle the edit button click
  const handleEditclick = async (e, clicked, reqid) => {
    try {
        setBclick('edit');
        setreqId(reqid);
        setClicked(false);

        // Clone the finalobj to avoid direct state mutation
        let tempfinalObj = { ...finalobj };
        const addassetobj = addassetdata?.entities?.[reqid];

        // Update tempfinalObj with data from addassetobj
        for (let key in tempfinalObj) {
            if (addassetobj?.[key] !== undefined) {
                tempfinalObj[key] = key === "quantity" 
                    ? parseInt(addassetobj[key], 10) 
                    : addassetobj[key];
            }
        }

        setFinalobj(tempfinalObj);

        // Fetch the file from the backend and handle errors
        const file = await fetchPDF(addassetobj, token);
        if (file) {
            setSelectedFile(file);
            setFileName(file.name ?? 'Unnamed File');
        } else {
            console.warn("No file received from fetchPDF.");
        }
    } catch (error) {
        console.error("Error in handleEditclick:", error);
        alert("Failed to fetch the file for editing. Please try again.");
    }
  };


  // Function to handle the submission of the edit
  const handleSubmitEditclick = (e, clicked, reqid) => {
    setSubmittedEditClick(clicked);
    setBclick('var');
    setreqId(reqid ?? '');
  }

  // Handle genback
  const genBackHandler = () => {
    setBclick('');
    setFinalobj({ ...FinalObjInitialVal });
    setreqId('');
    setClicked(false);
    setConclicked(false);
    setSelectedFile(null);
    setReselectedFile(null);
    setFile(null);

    if (inputPdfFile.current) {
        inputPdfFile.current.value = null;
    }
    if (inputFile.current) {
        inputFile.current.value = null;
    }
  };

  const handleSpec = (event, newValue, name) => {
    setFinalobj(prev => ({
        ...prev,
        specification: {
            ...prev.specification,
            [name]: newValue
        }
    }));
  };

  //************************************************************* */
  const handleTags = (event, bulkData) => {
    let updatedTags = [...tags]; // Initialize with existing tags

    // Update tags based on bulk data (e.g., Excel upload)
    if (bulkData?.length) {
        updatedTags = Array.from({ length: finalobj?.quantity }, (_, i) => ({
            oem_tag: bulkData[i]?.OEM_Tag?.toString() ?? '',
            org_tag: bulkData[i]?.ORG_Tag?.toString() ?? ''
        }));
    }

    // Update tags based on individual input changes
    if (event?.target?.name) {
        const { name, value } = event.target;

        const newTempTags = { ...temptags, [name]: value };
        setTemptags(newTempTags);

        updatedTags = Tags.map((tag, index) => ({
            oem_tag: newTempTags[`OEM_Tag${index + 1}`] ?? tag.oem_tag,
            org_tag: newTempTags[`ORG_Tag${index + 1}`] ?? tag.org_tag
        }));
    }

    setFinalobj(prev => ({
        ...prev,
        tags: updatedTags
    }));

    setTags(updatedTags);
  };

  const oemTagsValidation = tags?.map(elm => elm?.oem_tag).includes("" || undefined)

  const handleformInput = (event, name, newValue) => {
    // Date Validation
    if (event?.$d) {
      const selectedDate = dayjs(event.$d);
      if(name === "purchase_date" ) {
        // Check if the selected date is in the future
        if (selectedDate.isAfter(dayjs())) {
          alert('Purchase date cannot be in the future.');
          return  // Return previous state to avoid updating with invalid date
        }
      }

      if(name === "installation_date" ) {
        if (selectedDate.isAfter(dayjs()) || selectedDate.isBefore(dayjs(finalobj?.purchase_date))) {
          alert('Installation date cannot be before purchase date or in the future.');
          return  // Return previous state to avoid updating with invalid date
        }
      }

      if(name === "warrantyexp_date" ) {
        if (selectedDate.isBefore(dayjs(finalobj?.purchase_date)) || selectedDate.isBefore(dayjs(finalobj?.installation_date)) || selectedDate.isBefore(dayjs())) {
          alert('Warranty expiry date cannot be before Purchase date, Installation date or current date.');
          return  // Return previous state to avoid updating with invalid date
        }
      }
    }

    setFinalobj(prev => {
        let updatedObj = { ...prev };

        // Handle regular input events (e.g., text, select)
        if (event?.target?.name) {
            updatedObj[event.target.name] = event.target.value;
        }

        // Handle date picker input
        if (event?.$d) {
          updatedObj[name] = event.$d.toISOString();
        }

        // Handle dropdowns and specialized inputs
        if (newValue) {
            if (["category", "name"].includes(name)) {
                const { category, pur_store, cur_store, orderno } = updatedObj;
                
                // Reset the object while preserving specific fields
                updatedObj = { 
                    ...FinalObjInitialVal, 
                    orderno, 
                    category, 
                    pur_store, 
                    cur_store 
                };

                // Generate order number if category is updated
                if (name === "category") {
                    const categoryCount = Object.values(addassetdata?.entities)
                        .filter(x => x.category === category).length + 1;
                        
                    updatedObj.orderno = `${formatCategory(newValue)}${getFormattedDate()}${categoryCount}`;
                }
            }

            // Apply the new value
            updatedObj[name] = newValue;
        }

        return updatedObj;
    });
  };


  const navigate = useNavigate();
  const folderName = "contractdoc";
  let jsonData = {collection:"addasset", data:{}, type:"", oldPath:""}; // Update JSON data with actual data.
  
  // draft save
  const saveDraftHandle = async (e) => {
    e.preventDefault();

    const validateResult = await validatetags({"array":finalobj?.tags});
    if(validateResult?.error?.status === 400){

      setFinalobj(prev => ({
        ...prev,
        tags: []
      }));    
      setTags([]);
      setTemptags({});

      return alert(`Duplicate OEM Tags found. OEM Tags:${validateResult?.error?.data?.duplicateOEMTags
      }, ORG Tags:${validateResult?.error?.data?.duplicateORGTags}`)
    }

    setFinalSubClicked(false);

    const oldPath = addassetdata?.entities[reqid]?.pdfPath ?? "";
    let addstatus = { addstatus: 'draft' }
    jsonData.data = { ...finalobj, ...addstatus, ...(reqid?.length && { id: reqid }) }; // Update data field
    jsonData.type = reqid?.length ? "update" : "addnew"; // Set type   
    jsonData.oldPath = oldPath?.length && ((!selectedfile && !reselectedfile) || (reselectedfile)) ? oldPath : "";

    // Create FormData
    const formData = new FormData();
    if (selectedfile && (!reqid?.length || !oldPath?.length )) formData.append('file', selectedfile);
    if (reselectedfile) formData.append('file', reselectedfile);
    formData.append('jsonData', JSON.stringify(jsonData));

    try {
      const res = await uploadFile({ formData, folder: folderName }).unwrap();
      if (!reqid?.length) setreqId(res.insertedId); // Set reqid for new drafts
      alert(res.message);
    } catch (err) {
      console.error(err);
      alert("Failed to save draft. Please try again.");
    }    
  };

  //******************************final submit***********************************************/
  const finalSubmitHandle = async () => {
    // 1. **Validation Checks: Early Returns**
    if (Object.keys(duplicate).length) {
        return alert("Please check for duplicate values before submission.");
    }

    const validateResult = await validatetags({ array: finalobj?.tags });
    if (validateResult?.error?.status === 400) {
        return alert(`Duplicate OEM Tags found. OEM Tags: ${validateResult?.error?.data?.duplicateOEMTags}, ORG Tags: ${validateResult?.error?.data?.duplicateORGTags}`);
    }

    setFinalSubClicked(true);

    // 2. **Form Validation**
    const requiredFieldsFilled = (
        finalobj?.quantity &&
        finalobj?.unit_price?.length &&
        finalobj?.oem?.length &&
        finalobj?.vendor?.length &&
        finalobj?.purchase_date &&
        finalobj?.installation_date &&
        finalobj?.warrantyexp_date &&
        finalobj?.pur_store?.length &&
        finalobj?.olderAssetsLot?.length &&
        !oemTagsValidation &&
        finalobj?.tags?.length === parseInt(finalobj?.quantity)
    );

    if (!requiredFieldsFilled) {
        return alert("Please provide details in all Fields");
    }

    // 3. **Common Data Preparation**
    const status = { status: 'draft' };
    const addstatus = { addstatus: 'submitted' };
    const curr_editstatus = { curr_editstatus: false };

    const flow_details = {
        flow_data: [{
            person_details: {
                role: 'adder',
                id,
                name: getSingleuser?.[id]?.name,
                office: user_current_office,
                designation: designation[user_current_office],
                designationSuffix: designationSuffix[user_current_office],
                numSuffix: numSuffix[user_current_office],
            },
            editstatus: false,
            status: 'draft',
            remarks: '',
            time_stamp: new Date(),
        }],
    };

    // 4. **Determine New or Existing Request**
    const isNewSubmission = !reqid?.length;
    const oldPath = addassetdata?.entities[reqid]?.pdfPath ?? "";
    const body = {
        ...finalobj,
        ...addstatus,
        ...flow_details,
        ...status,
        ...curr_editstatus,
        ...(isNewSubmission ? {} : { id: reqid }),
    };

    jsonData.data = body;
    jsonData.type = isNewSubmission ? "addnew" : "update";
    jsonData.oldPath = ((oldPath?.length && !selectedfile && !reselectedfile) || (oldPath?.length && reselectedfile)) ? oldPath : "";

    // 5. **FormData Creation**
    const formData = new FormData();
    if (selectedfile && (isNewSubmission || !oldPath?.length)) formData.append('file', selectedfile);
    if (reselectedfile) formData.append('file', reselectedfile);
    formData.append('jsonData', JSON.stringify(jsonData));

    // 6. **File Upload & Navigation**
    try {
        const res = await uploadFile({ formData, folder: folderName }).unwrap();
        navigate('/management/assets/AssetMan');
        alert('Submitted');
    } catch (err) {
        alert(`Error: ${err}`);
        console.error("Submission failed:", err);
    }
  };


  const handleQuantity = (e) => {
    const value = e.target.value.trim();

    // 🛑 **Check for Empty Input:** Reset the quantity and tags if input is cleared
    if (value === "") {
        setFinalobj(prev => ({ ...prev, [e.target.name]: "" }));
        setTags([]);
        return;
    }

    const quantity = parseInt(value, 10);

    // 🛑 **Validation:** Ensure the quantity is a valid positive number
    if (isNaN(quantity) || quantity <= 0) {
        return alert("Please enter a valid value for Quantity.");
    }

    // 📦 **Update Final Object:** Using a shallow copy approach
    setFinalobj(prev => ({ ...prev, [e.target.name]: quantity }));
  };


  
  const handleOnBlur = (e, ind) => {
    const { name, value } = e.target;
    if (!value.length) return; // 🛑 Exit early if the input is empty

    const isOEM = name.includes("OEM_Tag");
    const tagType = isOEM ? "oem_tag" : "org_tag";

    // 🌟 Use a shallow copy for 'duplicate' state
    let tempDuplicate = { ...duplicate };

    // 🏷️ Get all tags up to the current index
    const tagList = tags.map(tag => tag[tagType]);
    const previousTags = tagList.slice(0, ind);

    // 🚦 Check for duplicate in the previous tags
    if (previousTags.includes(value)) {
        tempDuplicate[tagType] = { value, index: ind };
        setDuplicate(tempDuplicate);
    }

    // ✅ Check for any remaining duplicates globally
    const hasDuplicates = tagList
        .filter(tag => tag !== undefined)
        .some((tag, idx) => tagList.indexOf(tag) !== idx);

    // ❌ If no duplicates remain, remove the duplicate entry
    if (!hasDuplicates) {
        delete tempDuplicate[tagType];
        setDuplicate(tempDuplicate);
    }
  };

  //Downloading excel file format to prepare file for uploading tags.
  const downloadexcel = (e) => {
    e.preventDefault();

    // 🛑 Validate Quantity
    const quantity = Number(finalobj?.quantity);
    if (isNaN(quantity) || quantity < 1) {
        return alert("Please select a valid quantity");
    }

    // 📦 Prepare Data for Excel
    const excelData = Array.from({ length: quantity }, (_, i) => ({
        "Sl.No.": i + 1,
        "OEM_Tag": "",
        "ORG_Tag": ""
    }));

    // 🧾 Create Worksheet and Workbook
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // 💾 Trigger Download
    XLSX.writeFile(workbook, "uploadtags.xlsx");
  };


  // Supported file types for validation
  const allowedFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel"
  ];

  //Function for uploading excel file.
  const handleUploadFile = (e) => {
      const selectedFile = e.target.files[0];
  
      // 🛑 No File Selected
      if (!selectedFile) {
          setFileError("No file selected");
          setFile(null);
          return;
      }
  
      // 🚫 Invalid File Type
      if (!allowedFileTypes.includes(selectedFile.type)) {
          setFileError("Please select a valid Excel file (.xlsx or .xls)");
          setFile(null);
          inputFile.current.value = null; // Clear input field
          return;
      }
  
      // 📖 Read File as ArrayBuffer
      const reader = new FileReader();
  
      reader.onload = (e) => {
          try {
              const workbook = XLSX.read(e.target.result, { type: "array" });
              const worksheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[worksheetName];
              let data = XLSX.utils.sheet_to_json(worksheet);
  
              // 🧹 Preprocess data: Trim whitespace from all cell values
              data = data.map((row) =>
                  Object.fromEntries(
                      Object.entries(row).map(([key, value]) => [
                          key,
                          typeof value === "string" ? value.trim() : value
                      ])
                  )
              );
  
              // 🔍 Check for Duplicates
              const oemTagDuplicates = checkDuplicates(data, "OEM_Tag");
              const orgTagDuplicates = checkDuplicates(data, "ORG_Tag");
  
              if (oemTagDuplicates.size || orgTagDuplicates.size) {
                  inputFile.current.value = null; // Clear file input
                  alert(
                      `Duplicate values found in the uploaded Excel file:\n\n` +
                      `🆔 OEM_Tag: ${oemTagDuplicates.size ? [...oemTagDuplicates].join(", ") : "None"}\n` +
                      `🏷️ ORG_Tag: ${orgTagDuplicates.size ? [...orgTagDuplicates].join(", ") : "None"}`
                  );
                  return;
              }
  
              // 🔢 Validate Row Count
              if (data.length !== Number(finalobj.quantity)) {
                  inputFile.current.value = null;
                  alert(
                      `Row count mismatch!\n\n` +
                      `Expected Quantity: ${finalobj.quantity}\n` +
                      `Rows in File: ${data.length}`
                  );
                  return;
              }
  
              // ✅ File is Valid
              setFileError(null);
              setFileName(selectedFile.name);
              setFile(data);
              handleTags(undefined, data);
  
          } catch (error) {
              console.error("Error processing file:", error);
              setFileError("An error occurred while processing the Excel file.");
              setFile(null);
              inputFile.current.value = null;
          }
      };
  
      reader.onerror = () => {
          setFileError("An error occurred while reading the file.");
          setFile(null);
          inputFile.current.value = null;
      };
  
      reader.readAsArrayBuffer(selectedFile);
  };
  
  
  const uploadexcel = () => {
    if (!finalobj?.quantity) {
      return alert("Please enter quantity before uploading file.")
    }
    inputFile.current.click();
  };

  const deleteSelectFile = () => {
    if (inputPdfFile?.current) {
      inputPdfFile.current.value = null;
      inputPdfFile.current.type = "text"; // Reset input type to force re-selection
      inputPdfFile.current.type = "file";
      setSelectedFile(null);
      setReselectedFile(null);
    }
  };
  
  const deleteExcelSelectFile = () => {
    if (inputFile?.current) {
      inputFile.current.value = null;
    }
  
    setFinalobj(prevState => ({
      ...prevState,
      tags: []
    }));
  
    setFile(null);
  };
  //*******************************************************************
  return (
    <Container>
      <Wrapper>
        <AllWrapper>
          {!['draft', 'new', 'submitted', 'var', 'edit'].includes(bclick) && <OptionContainer onClick={handleNewclick}><InnerContainer >Add New Assets </InnerContainer></OptionContainer>}
          {!['draft', 'new', 'submitted', 'var', 'edit'].includes(bclick) && <OptionContainer onClick={handleDraftclick}><InnerContainer >Draft Add Assets </InnerContainer></OptionContainer>}
          {!['draft', 'new', 'submitted', 'var', 'edit'].includes(bclick) && <OptionContainer onClick={handleSubmittedclick}><InnerContainer >Submitted Assets </InnerContainer></OptionContainer>}
        </AllWrapper>

        <FormTabCont>
          {
            (bclick === 'draft') && <DraftTableCont>              
              <DraftTableWrap>
                <BackArrowContainer onClick={genBackHandler}>                  
                  <ArrowLeftIcon />
                  <BackButtonSpan >Back</BackButtonSpan>                  
                </BackArrowContainer>

                <CustomPaginationActionsTable handleEditclick={handleEditclick} />
              </DraftTableWrap>
            </DraftTableCont>}

          {submittedEditClick === 'clicked' ?
            <PreviewEdit
              setFinalobj = {setFinalobj}
              fetchPDF={fetchPDF}
              reqid={reqid}
              setreqId={setreqId}
              setBclick={setBclick}
              setSubmittedEditClick={setSubmittedEditClick}
              setSelectedFile={setSelectedFile}
              setClicked={setClicked}
            /> :
            (bclick === 'submitted') && <DraftTableCont>
              <DraftTableWrap>
                <BackArrowContainer onClick={genBackHandler}>
                  <ArrowLeftIcon />
                  <BackButtonSpan>Back</BackButtonSpan>
                </BackArrowContainer>
                <SubmittedTable handleSubmitEditclick={handleSubmitEditclick} />
              </DraftTableWrap>
            </DraftTableCont>}

          {(['new', 'edit'].includes(bclick)) && <FormCont>
            <BackArrowContainer onClick={genBackHandler}><ArrowLeftIcon /><BackButtonSpan >Back</BackButtonSpan></BackArrowContainer>
            {Object.values(allstoreoffices?.entities)?.map(x => x.storeoffice).includes(user_current_office) && <SelectContainer>
              <TextField
                label="Selected Store"
                value={finalobj?.pur_store || 'N/A'}
                InputProps={{
                  readOnly: true,
                }}
                sx={{ width: 600 }}
              />
            </SelectContainer>}
            <SelectContainer>
              <Autocomplete
                disabled={clicked}
                id="combo-box-demo"
                options={assetmasters ? Object.values(assetmasters.entities).filter(elm => Object.values(storedata)?.find(a => a.storeoffice === finalobj?.pur_store)?.ApplAssetCateg.includes(elm.Category)).map(x => x.Category) : []}
                sx={{ width: 600 }}
                value={finalobj?.category || null} // Ensure null fallback to avoid errors
                onChange={(event, newValue) => handleformInput(event, 'category', newValue)}
                isOptionEqualToValue={(option, value) => option === value} // Proper equality check for strings
                renderInput={(params) => <TextField {...params} label="Select Category" />}
              />
            </SelectContainer>
            {finalobj.category.length ? <SelectContainer>
              <Autocomplete
                disabled={clicked}
                id="combo-box-demo"
                options={Object.values(assetmasters?.entities).find(x => x.Category === finalobj?.category)?.Asset?.map(y => y.Name)}
                sx={{ width: 600 }}
                value={finalobj?.name || null}
                onChange={(event, newValue) => handleformInput(event, "name", newValue)}
                isOptionEqualToValue={(option, value) => option === value} // Proper equality check for strings
                renderInput={(params) => <TextField {...params} label="Select Asset Name" />}
              />
            </SelectContainer>:null}
            {finalobj?.name?.length ? <><HeadingWrap><Span>Provide following details of Asset</Span></HeadingWrap><SpecificationContainer>
              {clicked ?
                <AsetfmContainer>
                  <StyledForm>
                    <AsetfmWrapper>
                      <LeftAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            required={finalSubClicked}
                            value={finalobj?.unit_price || ''}
                            name='unit_price'
                            onChange={handleformInput}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Allow numbers and decimal points only
                            }}
                            label="Unit Cost"
                            size="small"
                            variant="outlined"
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={brandOptions}
                            sx={{ width: 400 }}
                            value={finalobj?.oem?.length?  finalobj?.oem : null}
                            onChange={(event, newValue) => handleformInput(event, "oem", newValue)}
                            isOptionEqualToValue={(option, value) => option === value} // Proper equality check for strings
                            renderInput={(params) => <TextField {...params} label="Select Brand/OEM Name:" />}
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={modelOptions}
                            sx={{ width: 400 }}
                            value={finalobj?.model_no?.length? finalobj?.model_no : null}
                            onChange={(event, newValue) => handleformInput(event, "model_no", newValue)}
                            isOptionEqualToValue={(option, value) => option === value} // Proper equality check for strings
                            renderInput={(params) => <TextField {...params} label="Enter Model No./Details:" />}
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={vendormaster? Object.values(vendormaster)?.map(x => x.vendorname):[]}
                            sx={{ width: 400 }}
                            value={finalobj?.vendor?.length? finalobj?.vendor : null}
                            onChange={(event, newValue) => handleformInput(event, "vendor", newValue)}
                          isOptionEqualToValue={(option, value) => option === value} // Proper equality check for strings
                            renderInput={(params) => <TextField {...params} label="Enter Vendor Name" />}
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={['Yes', 'No']}
                            sx={{ width: 400 }}
                            value={finalobj?.olderAssetsLot?.length? finalobj?.olderAssetsLot : null}
                            onChange={(event, newValue) => handleformInput(event, "olderAssetsLot", newValue)}
                            isOptionEqualToValue={(option, value) => option === value} // Proper equality check for strings
                            renderInput={(params) => <TextField {...params} label="Is this Lot of assets already with users?" />}
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                              <DateTimePicker
                                label="Purchase date"
                                value={dayjs(finalobj?.purchase_date) || null}
                                format="DD/MM/YYYY hh:mm a"
                                required={finalSubClicked}
                                onChange={(event) => handleformInput(event, 'purchase_date')}                               
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                              <DateTimePicker
                                label="Installation date"
                                value={dayjs(finalobj?.installation_date)}
                                format="DD/MM/YYYY hh:mm a"
                                onChange={(event) => handleformInput(event, 'installation_date')}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                              <DateTimePicker
                                label="warranty validity date"
                                value={dayjs(finalobj?.warrantyexp_date)}
                                format="DD/MM/YYYY hh:mm a"
                                required={finalSubClicked}
                                onChange={(event) => handleformInput(event, 'warrantyexp_date')}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            value={finalobj?.ledge_ref?.length? finalobj?.ledge_ref : ""}
                            name='ledge_ref'
                            onChange={handleformInput}
                            label="Any ledger Ref. No."
                            size="small"
                            variant="outlined"
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            value={finalobj?.bill_ref?.length? finalobj?.bill_ref : ""}
                            name='bill_ref'
                            onChange={handleformInput}
                            label="Billing Ref. No."
                            size="small"
                            variant="outlined"
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            value={finalobj?.remarks?.length? finalobj?.remarks : ""}
                            name='remarks'
                            onChange={handleformInput}
                            label="Remarks"
                            size="small"
                            variant="outlined"
                          />
                        </InputAsetfmWrapper>

                        <UploadPdfWrapper>
                          <InputFile type="file" onChange={handlePdfFileChange} ref={inputPdfFile}/>
                          <CustomFileUploadButton htmlFor="file-upload" onClick={handlePdfUploadButtonClick}>
                            Upload Related Contract Document
                          </CustomFileUploadButton>
                          {(selectedfile || reselectedfile) &&
                           <><span>
                              {selectedfile? selectedfile.name: reselectedfile.name}
                              </span>
                              <SelectFileReset type='button' onClick={() => deleteSelectFile()} >
                                &times;
                              </SelectFileReset>
                              <ViewButton type='button' onClick={handleviewFile}>
                                View File
                              </ViewButton>
                            </>}
                        </UploadPdfWrapper>
                      </LeftAsetfmWrapper>

                      <RightAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            required={true}
                            value={finalobj?.quantity ?? ''}
                            name='quantity'
                            onChange={handleQuantity}
                            label="Enter the Quantity"
                            size="small"
                            variant="outlined"
                          />
                        </InputAsetfmWrapper>

                        <TagsContainer>
                          {Array(Number(finalobj?.quantity)).fill("").map((elm, ind) => (
                            <TagsAsetfmWrapper key={ind}>
                              <InputAsetfmWrapper key={`OEM${ind}`}>
                                <TextField
                                  style={{ width: '250px' }}
                                  inputProps={{
                                    style: { height: '38px', color: (ind === duplicate?.oem_tag?.index) ?
                                    "red"
                                      :
                                    "black"
                                    }
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                  value={finalobj.tags[ind]?.oem_tag?.length ? finalobj.tags[ind]?.oem_tag : ""}
                                  name={`OEM_Tag${ind + 1}`}
                                  onChange={(event) => handleTags(event)}
                                  onBlur={(e) => handleOnBlur(e, ind)}
                                  label={`Enter OEM Tags ${ind + 1}`}
                                  size="small"
                                  variant="outlined"
                                />
                                {ind === duplicate?.oem_tag?.index &&
                                 <span style={{ color: "red", font: "small-caption" }}>
                                  Duplicate Value
                                </span>}
                              </InputAsetfmWrapper>
                              <InputAsetfmWrapper key={`ORG${ind}`}>
                                <TextField
                                  style={{ width: '250px' }}
                                  inputProps={{ 
                                    style: { height: '38px', color: (ind === duplicate?.org_tag?.index) ?
                                      "red"
                                        : 
                                      "black"
                                    }
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                  value={finalobj.tags[ind]?.org_tag?.length ? finalobj.tags[ind]?.org_tag : ""}
                                  name={`ORG_Tag${ind + 1}`}
                                  onChange={(event) => handleTags(event)}
                                  onBlur={(e) => handleOnBlur(e, ind)}
                                  label={`Enter ORG Tags ${ind + 1}`}
                                  size="small"
                                  variant="outlined"
                                />
                                {ind === duplicate?.org_tag?.index && <span style={{ color: "red", font: "small-caption" }}>Duplicate Value</span>}
                              </InputAsetfmWrapper>
                            </TagsAsetfmWrapper>
                          ))}
                        </TagsContainer>

                        <FormatContainer>
                          <Span>Do you want to upload in excel/CSV</Span>
                          <Buttonwrapper>
                            <ExlDownloadButton onClick={downloadexcel}>Download Format</ExlDownloadButton>
                            <InputFile type="file" onChange={(e) => handleUploadFile(e)} ref={inputFile} />
                            <CustomFileUploadButton htmlFor="file-upload" onClick={uploadexcel}>
                              Upload File
                            </CustomFileUploadButton>
                            {file && <><span>{fileName}</span><SelectFileReset type='button' onClick={() => deleteExcelSelectFile()} >&times;</SelectFileReset></>}
                          </Buttonwrapper>
                        </FormatContainer>
                      </RightAsetfmWrapper>                      
                    </AsetfmWrapper>
                  </StyledForm>

                  <StyledButton onClick={backhandleClick}>Back</StyledButton>
                </AsetfmContainer> :
                 
                <Specwrapper><FirstpageForm onSubmit={handlefirstpageformsubmit}>
                  {finalobj?.name?.length && Object.values(assetmasters?.entities)?.find(x => x.Category === finalobj?.category).Asset.find(y => y.Name === finalobj?.name)?.Specifications?.map((elm, index) => (<SpecItemwrapper key={index}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={ Object.values(assetmasters?.entities)?.find(x => x.Category === finalobj?.category).Asset.find(y => y.Name === finalobj?.name)?.Specifications.map(b => Object.values(b))[index].flat(3)
                      }
                      sx={{ width: 600 }}
                      value={ finalobj?.specification[Object.keys(elm)[0]] ?? null}
                      required={true}
                      onChange={(event, newValue) => { handleSpec(event, newValue, Object.keys(elm)[0]) }}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => <TextField {...params} label={Object.keys(elm)[0]} />}
                    />
                  </SpecItemwrapper>))}
                </FirstpageForm></Specwrapper>
                }
            </SpecificationContainer > </>:null}

            {(clicked !== true && finalobj?.name?.length) ? <ButtonContainer>
              <ConfirmButton onClick={handleConclick}>Confirm</ConfirmButton>
              <NextButton
               onClick={NexthandleClick}
               disabled={!conclicked || Object.values(assetmasters?.entities)?.find(x => x.Category === finalobj?.category).Asset.find(y => y.Name === finalobj?.name)?.Specifications?.length !== Object.values(finalobj?.specification)?.length || !finalobj?.pur_store?.length}
              >
                Next
              </NextButton>
            </ButtonContainer>:null}

            {clicked && <DraftSubButtonCon><StyledButton onClick={saveDraftHandle}>Save Draft</StyledButton>
              <SubmitButton
               type='submit'
               onClick={finalSubmitHandle}
               disabled={isLoading}
              >
                {isLoading? "Loading...":"Submit"}
              </SubmitButton>
            </DraftSubButtonCon>}
          </FormCont>}
        </FormTabCont>
      </Wrapper >

      <PdfModal
        show = {modalIsOpen}
        onClose = {closeModal}
        pdfUrl = {selectedfile? URL.createObjectURL(selectedfile) : reselectedfile? URL.createObjectURL(reselectedfile):null}
      />

    </Container>

  )
}

export default Addassets;